import { useQuery } from '@tanstack/react-query';

import { useAvApi } from '@app-velocity/av-api-v2';

export const useGetScenarioQuery = (
  workspaceId?: string,
  scenarioId?: string,
  mode: 'authorized' | 'guest' = 'authorized'
) => {
  const { prototypes, guestPrototypes } = useAvApi();

  const data = useQuery({
    enabled: !!scenarioId && !!workspaceId && !!mode,
    queryKey: ['scenario', workspaceId, scenarioId],
    queryFn: async () => {
      if (!scenarioId || !workspaceId) return;

      if (mode === 'authorized') {
        const data =
          await prototypes.getV2ProjectsPrototypesByProjectIdAndPrototypeId({
            projectId: workspaceId,
            prototypeId: scenarioId,
          });

        return data.data;
      }

      if (mode === 'guest') {
        const data =
          await guestPrototypes.getV2GuestPrototypesByProjectIdAndPrototypeId({
            projectId: workspaceId,
            prototypeId: scenarioId,
          });

        return data.data;
      }

      return null;
    },
  });

  return data;
};
